export const routePath = {
  home: `/`,
  home2: `/dashboard/:id`,
  sign_in: `/sign-in/:type`,
  sign_up: `/sign-up/:type`,
  uploadResume: `/upload-resume`,
  google: `/auth/google`,
  googleOauth: `/oauth/google`,
  linkedin: `/auth/linkedin`,
  linkedinOauth: `/oauth/linkedin`,
  zoomOauth: `/oauth/zoom`,
  forgot_password: `/forgot-password/:type?`,
  reset_password: `/password-reset`,
  jobs: `/jobs`,
  jobsPreview: `/jobs-preview`,
  jobsCreation2: `/jobs-add-2`,
  jobsCreation: () => ({
    format: `/jobs-add/:id?`,
    path: `/jobs-add`,
  }),

  jobsEdit: (id?: number | string) => ({
    format: `/jobs-edit/:id`,
    path: `/jobs-edit/${id}`,
  }),
  // jobsPreview: (id?: number | string) => ({
  //   format: `/jobs-preview/:id`,
  //   path: `/jobs-preview/${id}`,
  // }),
  jobDetails: (id?: number | string) => ({
    format: `/jobs/:id`,
    path: `/jobs/${id}`,
  }),
  viewApplicants: (id?: number | string) => ({
    format: `/listing-applicants/:id`,
    path: `/listing-applicants/${id}`,
  }),
  talents: `/talents`,
  talentDetails: (id?: number | string) => ({
    format: `/talents/:id`,
    path: `/talents/${id}`,
  }),
  folders: `/folders`,
  folderDetails: (id?: number | string) => ({
    format: `/folders/:id`,
    path: `/folders/${id}`,
  }),

  // chats: `/smart-screen/chats`,
  chatDetails: (id?: number | string) => ({
    format: `/smart-screen/chats/:id`,
    path: `/smart-screen/chats/${id}`,
  }),

  recruiterDetails: (id?: number | string) => ({
    format: `/recruiter/:id`,
    path: `/recruiter/${id}`,
  }),

  downloadcv: (id?: number | string) => ({
    format: `/downloadcv/:id`,
    path: `/downloadcv/${id}`,
  }),

  chatProfiles: (id?: number | string) => ({
    format: `/smart-screen/chats/:id/profiles`,
    path: `/smart-screen/chats/${id}/profiles`,
  }),

  chatProfilesById: (id?: number | string, profileId?: number | string) => ({
    format: `/smart-screen/chats/:id/:profileId`,
    path: `/smart-screen/chats/${id}/${profileId}`,
  }),

  pricing: `/pricing`,
  verifyPayment: `/payment/verify`,
  teamInvite: `/team-invitation`,
  message: `/message:id`,
  messages: `/message`,
  feedbacks: `/feedback`,
  jobOffers: `/jobOffers`,
  confirmJobOffer: `/confirmJobOffer`,
  talentFeedback: `/talent-feedback`,
  settings: `/settings`,
  profile: `/settings/profile`,
  profileCompany: `/settings/profile-company`,
  profileCompanySettings: `/settings/profile-company-edit`,

  education: `/settings/education`,
  urls: `/settings/urls`,
  experience: `/settings/experience`,
  interests: `/settings/interests`,
  certifications: `/settings/certifications`,
  projects: `/settings/projects`,

  documents: `/settings/documents`,
  password: `/settings/password`,
  notifications: `/settings/notifications`,
  billings: `/settings/billings`,
  personalityTest: `/settings/personality-test`,
  meetingSettings: `/meeting-settings`,
  postingSettings: `/posting-settings`,
  cvchat: "/smart-screen",
  cvchatHistory: "/smart-screen-history",
  chathistory: "/chat-history",
  invites: `/invites`,
  recruierInvites: `/recruiter-invites`,
  team: `/team`,
  addteammember: `/addteammember`,

  invitestatus: "/invites/:status",
  invitedetails: "/invites/:id/",

  recruierInvitestatus: "/recruiter-invites/:status",
  recruierInvitedetails: "/recruiter-invites/:id/",

  terms: "/legal/terms-and-conditions",
  privacy: "/legal/privacy-policy",

  enterpriseDashboard: `/enterprise/dashboard`,
};

